var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invoice-create-page"},[_c('UserRoleForm',{attrs:{"page":"create","submitted":_vm.submitted},on:{"FormUpdate":function($event){_vm.FormUpdate = 1},"onSubmit":function($event){_vm.onSubmit($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }